var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[(_vm.show)?_c('div',{staticClass:"wrap-now-loading f fh"},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }